import React from 'react';
import { useTranslation } from 'react-i18next';

import { languages } from '../i18n';
import { StyledLobbyLanguage } from './StyledTable';
import i18next from 'i18next';

import { FaLanguage } from '../util/reactIcons';

export const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const options = languages.map((lang) => {
    return <option key={lang.label} value={lang.key}>{lang.label}</option>;
  });

  const onChangePacsURL = (e) => {
    i18next
      .changeLanguage(e.target.value)
      .then(() => sessionStorage.setItem('i18nextLng', e.target.value));
  }

  return (
    languages.length && (
      <StyledLobbyLanguage>
        <FaLanguage size={45} />
        <select value={i18n.language} onChange={onChangePacsURL}>
          {options}
        </select>
      </StyledLobbyLanguage>
    )
  );
};

export default React.memo(LanguageSelector);
